import { colors } from "../../Styles";

  export type Condition = {
    conditionId: number; //DataTYPE ID, static
    conditionName: string; 
    conditionColorTag: string;
  };
  
  export const ConditionData: Condition[] = [
    {
      conditionId: 1,
      conditionName: "Normal",
      conditionColorTag: colors.systemGreen,
    },
    {
      conditionId: 2,
      conditionName: "Skinny",
      conditionColorTag: colors.systemYellow,
    },
    {
      conditionId: 3,
      conditionName: "Very Skinny",
      conditionColorTag: colors.systemYellow,
    },
    {
      conditionId: 4,
      conditionName: "Fat",
      conditionColorTag: colors.systemRed,
    },
    {
      conditionId: 5,
      conditionName: "Very Fat",
      conditionColorTag: colors.systemRed,
    },
  ]

